import React from 'react';
import Note from './Note';

export default function NoteSection() {
  return (
    <section className="note_section">
      <div className="note_container">
        <Note />
      </div>
    </section>
  )
}
